import React, { useState, useEffect } from "react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import KineticMarquee from "../components/KineticMarquee";
import Services from "../components/Services";
import Programs from "../components/Programs";
import Houston from "../components/Houston";
import Results from "../components/Results";
import Assessment from "../components/Assessment";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    // Track visit (best-effort)
    api.post("/visits").catch(() => {});
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="bg-[#0A0A0A] text-white min-h-screen grain" data-testid="landing-page">
      <Navbar scrolled={scrolled} />
      <main>
        <Hero />
        <KineticMarquee />
        <Services />
        <Programs />
        <Houston />
        <Results />
        <Assessment />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
